import axios from "axios";
import { notification } from 'antd';
import { Mode } from '../App';

let http = {
    post: '',
    get: ''
}
axios.interceptors.request.use(config => {    
    if(localStorage.getItem('Is_Lock')){
        let times= localStorage.getItem('runningtime')        
        let counter=localStorage.getItem('lockTimer')
        
        if(times===null || counter===null || (new Date().getTime()-times)>counter*1000*60){
            window.location.href = '/#/login';
            // localStorage.clear()
        }
    }
    
    config.headers = {
        ...config.headers,
        "Content-Type": "application/json; charset=utf-8",
        'Authorization': `Bearer ${localStorage.getItem('token')}`
    };
    return config
}, (err) => {
    return Promise.reject(err);
})
axios.interceptors.response.use(res=>{
    // if (res.data.code > 2000){
        // window.location.href = '/login';
        // return Promise.reject("登录超时");
    // }
    
    return res

},err=>{
    
    if(err?.response?.status===401){

    }
    return   Promise.reject(err);
})
http.post = function (api, data,val='') {
    return new Promise((resolve, reject) => {
        var url ="";
        if(Mode==='local'){
            url="http://127.0.0.1:8086";        
        }
        let conf = {}
        if(val!==''){
            conf={headers:{'mySign':encodeURIComponent(val, "utf-8")}}
        }
        
        axios.post(url+api, data,conf).then((res) => {
            if (api.indexOf("/v1/") > -1 || api.indexOf("/v3/") > -1) {
                if (res.data.code === 0) {
                    notification['success']({
                        message: '操作成功',
                        description: '',
                        duration: 2,
                    });
                }else{
                    if(res.data.msg==='命令已缓存'){
                        notification['success']({
                            message: '操作成功',
                            description: res.data.msg,
                            duration: 2,
                        });
                    }else{
                        notification['error']({
                            message: '操作失败',
                            description: res.data.msg,
                            duration: 2,
                        });
                    }
                }
                // if (res.data.code == 200) {
                    
                // }
            }
            resolve(res.data)
        })
    })
}

http.get = function (api, data) {
    return new Promise((resolve, reject) => {
        var url ="";
        if(Mode==='local'){
            url="http://127.0.0.1:8086";        
        }
        axios.get(url+api, data).then((res) => {
            // if (res.data.code >2000) {
            //     //密钥失败
            //     console.log("密钥过期")
            //     if (window.require) {
            //         const electron = window.require('electron');
            //         if (electron !== undefined) {
            //             const { ipcRenderer } = electron;
            //             ipcRenderer.send('close')
            //         }
            //     }
            //     window.location.href = '/login';
            // }
            resolve(res.data)
        })
    })
}

http.put = function (api, data,val='') {
    return new Promise((resolve, reject) => {
        var url ="";
        if(Mode==='local'){
            url="http://127.0.0.1:8086";        
        }
        let conf = {}
        if(val!==''){
            conf={headers:{'mySign':encodeURIComponent(val, "utf-8")}}
        }
        axios.put(url+api, data,conf).then((res) => {
            if (res.data.code === 0) {
                notification['success']({
                    message: '操作成功',
                    description: '',
                    duration: 2,
                });
            }
            if (res.data.code === 200) {
                notification['error']({
                    message: '操作失败',
                    description: res.data.msg,
                    duration: 2,
                });
            }
            resolve(res.data)
        })
    })
}

http.delete = function (api, data) {
    return new Promise((resolve, reject) => {
        var url ="";
        if(Mode==='local'){
            url="http://127.0.0.1:8086";        
        }
        axios.delete(url+api, data).then((res) => {
            if (res.data.code === 0) {
                notification['success']({
                    message: '操作成功',
                    description: '',
                    duration: 2,
                });
            }
            if (res.data.code === 200) {
                notification['error']({
                    message: '操作失败',
                    description: res.data.msg,
                    duration: 2,
                });
            }
            resolve(res.data)
        })
    })
}

export default http